import { Card } from './types';

export const cards: Card[] = [
  {
    id: 1,
    title: 'Freight Forwarder',
    description: 'Leverage our digital freight forwarding tools and extensive network to expand your operational reach. Stay ahead of the competition and boost your logistics capabilities by becoming a member of the DF Alliance network.',
    url: '/freight-forwarder',
  },
  {
    id: 2,
    title: 'Freight Dictionary',
    description: 'Uncover the complexities of freight management with our comprehensive freight dictionary. Understand key terms, technology, and industry jargon that are key to the supply chain space.',
    url: '/freight-dictionary',
  },
  {
    id: 3,
    title: 'Blogs',
    description: 'Stay abreast with the latest AI, logistics technology and market trends in freight management. Explore key industry insights, innovations, guidelines and global developments in our comprehensive blogs.',
    url: '/blog',
  }
];